import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-text',
  templateUrl: './formly-text.component.html',
  styleUrls: ['./formly-text.component.scss'],
})
export class FormlyTextComponent extends FieldType {
  onClick(event: Event) {
    this.props.onClick(this.field, event)
  }
}
